/**
 * Created with IntelliJ IDEA.
 * User: tomers
 * Date: 7/13/14
 * Time: 4:14 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/audit-trail/auditTrailGridView.tmpl");
    var AuditTrailGridRowView = require("manager-views/audit-trail/AuditTrailGridRowView");
    var AuditTrailGridEmptyView = require("manager-views/audit-trail/AuditTrailGridEmptyView");

    var AuditTrailGridView = {};

    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {
        AuditTrailGridView = Marionette.GraphQLGridView.extend({
            template : template,
            itemViewContainer : "tbody",
            itemView : AuditTrailGridRowView,
            emptyView: AuditTrailGridEmptyView,
            className: "table-main ui-table",
            ui: {
                "table" : "table"
            },
            initialize:  function (options) {
                this.channel = options.channel;
            },

            itemViewOptions: function () {
                return {
                    channel: this.channel
                };
            }
        });
    });
    return AuditTrailGridView;
});

